"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var GlobeIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.711 16H9.29c.317 2.13.862 3.868 1.469 4.915a8.937 8.937 0 01-2.51-.732c-.444-1.194-.78-2.615-.991-4.183H3.936a8.935 8.935 0 01-.713-2h3.839a31.998 31.998 0 010-4H3.223c.16-.701.4-1.371.713-2h3.32c.211-1.568.548-2.99.992-4.183a8.937 8.937 0 012.51-.732C10.151 4.132 9.606 5.871 9.288 8h5.423c-.317-2.13-.862-3.868-1.469-4.915a8.937 8.937 0 012.51.732c.444 1.194.78 2.615.991 4.183h3.321c.313.629.554 1.299.713 2h-3.839a31.998 31.998 0 010 4h3.839c-.16.701-.4 1.371-.713 2h-3.32c-.211 1.568-.548 2.99-.992 4.183-.783.36-1.626.61-2.51.732.607-1.047 1.152-2.786 1.47-4.915zm.218-2a28.231 28.231 0 000-4H9.071a28.231 28.231 0 000 4h5.858z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "nonzero",
    d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0 2C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11z",
    opacity: ".8"
  })));
});
GlobeIcon.category = 'Map';
var _default = GlobeIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/GlobeIcon.js
// module id = 1087
// module chunks = 0